(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ep-bundle-return"] && !Shopify.designMode) return;
  try {
    (() => {
    const key = 'ep_bundle_return_v1';
    const ttl = 2 * 60 * 60 * 1000;
    const origin = 'https://purposeful-six-bag-granola.lovable.app';
    const paths = { box4: '/buy-3-get-1', box6: '/' };
    const allowed = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'trybe'];
    const banner = document.getElementById('ep-bundle-return');
    if (!banner) return;
    let current = null;
    const remove = () => { try { sessionStorage.removeItem(key); } catch (_) {} };
    const validate = (value) => {
      if (!value || !Object.hasOwn(paths, value.offer) || typeof value.url !== 'string' || value.url.length > 4096) return null;
      if (!Number.isFinite(value.at) || Date.now() - value.at >= ttl || value.at > Date.now()) return null;
      try {
        const raw = new URL(value.url);
        if (raw.origin !== origin || raw.pathname !== paths[value.offer] || raw.username || raw.password) return null;
        const clean = new URL(paths[value.offer], origin);
        allowed.forEach(name => { const v = raw.searchParams.get(name); if (v && v.length <= 512 && !/[\u0000-\u001f]/.test(v)) clean.searchParams.set(name, v); });
        return { offer: value.offer, url: clean.href, at: value.at };
      } catch (_) { return null; }
    };
    const read = () => { try { return validate(JSON.parse(sessionStorage.getItem(key))); } catch (_) { return null; } };
    const paint = () => {
      current = validate(current);
      banner.hidden = !current;
      if (!current) { remove(); return; }
      banner.querySelector('[data-ep-return-link]').href = current.url;
      banner.querySelectorAll('[data-ep-offer]').forEach(el => { el.hidden = el.dataset.epOffer !== current.offer; });
    };
    const incoming = new URL(location.href);
    if (incoming.searchParams.has('ep_offer') || incoming.searchParams.has('ep_return')) {
      current = validate({ offer: incoming.searchParams.get('ep_offer'), url: incoming.searchParams.get('ep_return'), at: Date.now() });
      if (current) { try { sessionStorage.setItem(key, JSON.stringify(current)); } catch (_) {} } else remove();
      incoming.searchParams.delete('ep_offer');
      incoming.searchParams.delete('ep_return');
      try { history.replaceState(history.state, '', incoming.pathname + incoming.search + incoming.hash); } catch (_) {}
    } else current = read();
    paint();
    banner.querySelector('[data-ep-return-dismiss]').addEventListener('click', () => { current = null; remove(); paint(); });
    banner.querySelector('[data-ep-return-link]').addEventListener('click', event => { if (!validate(current)) { event.preventDefault(); current = null; paint(); } });
    window.addEventListener('pageshow', event => { if (event.persisted) { current = read(); paint(); } });
    document.addEventListener('visibilitychange', () => { if (!document.hidden) paint(); });
  })();
  } catch(e) { console.error(e); }
})();

})();
